'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.serviceActionsFactory = exports.getId = void 0;
var tslib_1 = require('tslib');
var redux_1 = require('redux');
var createActions_1 = require('../utils/createActions');
function bindActions(obj, store) {
    var result = {};
    function keyMap(key) {
        var subObj = obj[key];
        result[key] =
            typeof subObj === 'function'
                ? (0, redux_1.bindActionCreators)(subObj, store.dispatch)
                : bindActions(subObj, store);
    }
    Object.keys(obj).forEach(keyMap);
    return result;
}
function getId(fn) {
    var _a;
    var id = (_a = fn) === null || _a === void 0 ? void 0 : _a.id;
    if (typeof id !== 'string') {
        throw new Error('Target is not an operation');
    }
    return id;
}
exports.getId = getId;
function cache(fn, getKey) {
    var cache = {};
    return function cached() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var key = getKey.apply(void 0, (0, tslib_1.__spreadArray)([], (0, tslib_1.__read)(args), false));
        cache[key] = cache[key] || fn.apply(void 0, (0, tslib_1.__spreadArray)([], (0, tslib_1.__read)(args), false));
        return cache[key];
    };
}
function serviceCacheKey(service, bind) {
    return ''.concat(service, '_').concat(service.getUUID(), '_').concat(!!bind);
}
function serviceActionsFactory() {
    return cache(function (service, bind) {
        var actions = (0, createActions_1.createActions)(service, service.getUUID());
        return bind ? bindActions(actions, bind) : actions;
    }, serviceCacheKey);
}
exports.serviceActionsFactory = serviceActionsFactory;
